import Navbar from "../Navbar"
function InformationPage() {
  return (
    <>
      <Navbar></Navbar>
      <div className='container-info'>
        <>
          <h1>Dev: Alice</h1>
        </>
        <>
          <h3>Вторая проработанная версия Todo App на React.</h3>
        </>
        <>
          <h4>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus
            illum voluptatem minus ullam omnis accusantium hic, vitae sunt et,
            inventore perferendis aliquid exercitationem ut explicabo,
            recusandae mollitia aperiam eos ratione.
          </h4>
        </>
      </div>
    </>
  )
}
export default InformationPage
